const CONFIRM_RETURN_ORDER = 'CONFIRM_RETURN_ORDER';

export { CONFIRM_RETURN_ORDER };
